import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/common/login';
import DashboardContent from './components/dashboard/dashboardcontent';
import Account from './components/accounts/accountContent';
import PartiesContent from './components/parties/partiescontent';
import EditPartyPage from './components/parties/editparty';
import AddPartyPage from './components/parties/addparty';
import PartyDetails from './components/parties/party';
import ItemsContent from './components/items/itemcontent';
import EditItemPage from './components/items/edititem';
import AddItemPage from './components/items/additem';
import ItemDetails from './components/items/item';
import SalesContent from './components/sales/salecontent';
import EditSalePage from './components/sales/editsale';
import AddSalePage from './components/sales/addsale';
import SaleDetails from './components/sales/sale';
import LedgerContent from './components/ledger/ledgercontent';
import AddLedgerPage from './components/ledger/addledger';

import Invoice from './components/common/invoicePdf';
import IMS from './components/purchases/ims/imscontent';
import AddImsPage from './components/purchases/ims/addIms';
import GSTR from './components/purchases/gstr';

import AllUsers from './components/admin/allUsers';
import AddUser from './components/admin/addUser';
import ChangePassword from './components/admin/changePassword';

import { Helmet } from "react-helmet";

const Sidebar = lazy(() => import('./components/common/sidebar'));

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('token');
        setIsAuthenticated(!!token);
      } catch (error) {
        console.error("Error accessing localStorage:", error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();

    window.addEventListener('storage', checkAuth);

    return () => {
      window.removeEventListener('storage', checkAuth);
    };
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="flex h-screen bg-gray-100">
        <Helmet>
          <title>Invoice</title>
        </Helmet>

        {isAuthenticated ? (
          // <Suspense fallback={<div>Loading Sidebar...</div>}>
          //   <Sidebar />
          // </Suspense>
          <Sidebar />
        ) : null}

        <div className="flex-1 overflow-y-auto">
          <Routes>
            <Route path="/login" element={isAuthenticated ? <DashboardContent /> : <Login />} />

            {/* If authenticated, always redirect to dashboard from root. */}
            {/* <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace={true} /> : <Navigate to="/login" replace={true} />} /> */}

            <Route path="/admin/users" element={isAuthenticated ? <AllUsers /> : <Navigate to="/login" replace />} />
            <Route path="/admin/add-user" element={isAuthenticated ? <AddUser /> : <Navigate to="/login" replace />} />

            <Route path="/accounts/profile" element={isAuthenticated ? <Account /> : <Navigate to="/login" replace />} />
            <Route path="/accounts/change-password" element={isAuthenticated ? <ChangePassword /> : <Navigate to="/login" replace />} />


            <Route path="/invoice/:id" element={isAuthenticated ? <Invoice /> : <Navigate to="/login" replace />} />
            <Route path="/dashboard" element={isAuthenticated ? <DashboardContent /> : <Navigate to="/login" replace />} />
            <Route path="/parties" element={isAuthenticated ? <PartiesContent /> : <Navigate to="/login" replace />} />
            <Route path="/parties/add" element={isAuthenticated ? <AddPartyPage /> : <Navigate to="/login" replace />} />
            <Route path="/parties/edit/:id" element={isAuthenticated ? <EditPartyPage /> : <Navigate to="/login" replace />} />
            <Route path="/parties/:partyId" element={isAuthenticated ? <PartyDetails /> : <Navigate to="/login" replace />} />
            <Route path="/items" element={isAuthenticated ? <ItemsContent /> : <Navigate to="/login" replace />} />
            <Route path="/items/add" element={isAuthenticated ? <AddItemPage /> : <Navigate to="/login" replace />} />
            <Route path="/items/edit/:id" element={isAuthenticated ? <EditItemPage /> : <Navigate to="/login" replace />} />
            <Route path="/items/:itemId" element={isAuthenticated ? <ItemDetails /> : <Navigate to="/login" replace />} />
            <Route path="/sales" element={isAuthenticated ? <SalesContent /> : <Navigate to="/login" replace />} />
            <Route path="/sales/add" element={isAuthenticated ? <AddSalePage /> : <Navigate to="/login" replace />} />
            <Route path="/sales/edit/:id" element={isAuthenticated ? <EditSalePage /> : <Navigate to="/login" replace />} />
            <Route path="/sales/:saleId" element={isAuthenticated ? <SaleDetails /> : <Navigate to="/login" replace />} />
            <Route path="/ledger" element={isAuthenticated ? <LedgerContent /> : <Navigate to="/login" replace />} />
            <Route path="/ledger/add" element={isAuthenticated ? <AddLedgerPage /> : <Navigate to="/login" replace />} />
            <Route path="/purchases/ims" element={isAuthenticated ? <IMS /> : <Navigate to="/login" replace />} />
            <Route path="/purchases/ims/add" element={isAuthenticated ? <AddImsPage /> : <Navigate to="/login" replace />} />
            <Route path="/purchases/gstr" element={isAuthenticated ? <GSTR /> : <Navigate to="/login" replace />} />
            <Route path="*" element={isAuthenticated ? <Navigate to="/dashboard" replace={true} /> : <Navigate to="/login" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;